<template>
  <div class="load-outer">
    <div class="dark-overlay" style="justify-content:center;align-items:center;backdrop-filter:blur(5px);">
      <div class="load-box">
        <div class="fall-ball" id="fall-b"><h5>b</h5></div>
        <div class="fall-ball" id="fall-r"><h5>r</h5></div>
        <div class="fall-ball" id="fall-e"><h5>e</h5></div>
        <div class="fall-ball" id="fall-e2"><h5>e</h5></div>
        <div class="fall-ball" id="fall-z"><h5>z</h5></div>
        <div class="fall-ball" id="fall-i"><h5>i</h5></div>
        <div class="fall-ball" id="fall-space"></div>
        <div class="fall-ball" id="fall-p"><h5>p</h5></div>
        <div class="fall-ball" id="fall-r2"><h5>r</h5></div>
        <div class="fall-ball" id="fall-o"><h5>o</h5></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {

    }
  },
  mounted(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
}
</script>

<style scoped>

.load-outer {
  top: 0px;
  left: 0px;
  bottom: 0px;
  right: 0px;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  background-image: url('https://brebe-s3-storage-matt.s3-eu-west-1.amazonaws.com/breezi-pro/city_center+copy.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  overflow: hidden;
}

.load-box {
  width: 400px;
  height: 200px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.fall-ball {
  width: 35px;
  height: 35px;
  background-color: rgb(0, 153, 191);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  animation: intoPlaceL 5s infinite linear;
  transition: filter 0.3s ease;
  color: lightblue;
  border-radius: 0px;
}

h5 {
  animation: appearAtEnd 5s infinite linear;
  transition: filter 0.3s ease;
  opacity: 0;
  font-size: 1.5em;
  font-family: Comfortaa, sans-serif;
}

#fall-b {
  animation-delay: .25s;
}

#fall-r {
  animation-delay: .5s;
}

#fall-e {
  animation-delay: .75s;
}

#fall-e2 {
  animation-delay: 1s;
}

#fall-z {
  animation-delay: 1.25s;
}

#fall-i {
  animation-delay: 1.5s;
}

#fall-space {
  background-color: rgba(0, 0, 0, 0);
  animation: none;
  width: 5px;
}

#fall-p {
  animation-delay: 1.75s;
}

#fall-r2 {
  animation-delay: 2s;
}

#fall-o {
  animation-delay: 2.25s;
}

#fall-b h5 {
  animation-delay: .25s;
}

#fall-r h5 {
  animation-delay: .5s;
}

#fall-e h5 {
  animation-delay: .75s;
}

#fall-e2 h5 {
  animation-delay: 1s;
}

#fall-z h5 {
  animation-delay: 1.25s;
}

#fall-i h5 {
  animation-delay: 1.5s;
}

#fall-p h5 {
  animation-delay: 1.75s;
}

#fall-r2 h5 {
  animation-delay: 2s;
}

#fall-o h5 {
  animation-delay: 2.25s;
}

@keyframes intoPlaceL {
  0% {
    background-color: lightblue;
  }
  30% {
    background-color: rgb(0, 153, 191);
    margin-top: 40%;
    transform: rotateX(360deg);
  }
  70% {
    background-color: rgb(0, 153, 191);
    margin-top: 40%;
    transform: rotateX(360deg);
  }
  100% {
    background-color: lightblue;
  }
}

@keyframes appearAtEnd {
  20% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
  80% {
    opacity: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/util/Loading.vue